import i18n, { type TranslationKeys } from './configuration';

export enum TranslationGroup {
  Swire = 'swire',
  Cbre = 'cbre',
}

/**
 * Maps whitelabel instance identifiers to translation keys that should be suppressed (return '').
 * Use this instead of adding empty string values to translation JSON files.
 * Add new instance → suppressed key mappings here alongside wt(key) calls in components.
 */
export const SUPPRESSED_KEYS_BY_INSTANCE: Partial<Record<string, TranslationKeys[]>> = {
  nashvilleyards: [
    'web.login.loginEmail.subtitle',
    'web.login.loginEmail.subtitle.workplaceOnboarding',
  ],
};

/**
 * Maps whitelabel instance identifiers to their shared translation group.
 * Instances omitted here fall back to instance key then base key only.
 * Add new instance → group mappings here in the same PR as the suffix keys.
 */
export const TRANSLATION_GROUP_BY_INSTANCE = {
  taikooplace: TranslationGroup.Swire,
  pacificplaceoffices: TranslationGroup.Swire,
  hosty: TranslationGroup.Cbre,
} satisfies Partial<Record<string, TranslationGroup>>;

export function getTranslationGroupForInstance(
  instance: string
): TranslationGroup | undefined {
  return (TRANSLATION_GROUP_BY_INSTANCE as Partial<Record<string, TranslationGroup>>)[instance];
}

/**
 * Resolves the most specific translation key for a whitelabel context.
 * Priority: {baseKey}.{instance} → {baseKey}.{translationGroup} → {baseKey}
 */
export function resolveWhitelabelTranslationKey(
  baseKey: string,
  ctx: { instance: string; translationGroup?: string }
): string {
  const instanceKey = `${baseKey}.${ctx.instance}`;
  if (i18n.exists(instanceKey)) return instanceKey;

  if (ctx.translationGroup) {
    const groupKey = `${baseKey}.${ctx.translationGroup}`;
    if (i18n.exists(groupKey)) return groupKey;
  }

  return baseKey;
}
